export const   fetching= 'FETCHING_AMENITIES'
export const   fetched= 'FETCHED_AMENITIES'
export const   error= 'ERROR_FETCHING_AMENITIES'
